;(function () {
  function getMediaTarget(button) {
    var dm = button.closest('deferred-media')
    if (!dm) return null
    var iframe = dm.querySelector('iframe.js-vimeo')
    if (iframe) return { kind: 'vimeo', el: iframe, dm: dm }
    var video = dm.querySelector('video.js-html5-video')
    if (video) return { kind: 'html5', el: video, dm: dm }
    return null
  }

  function setVideoToggleState(button, playing) {
    button.setAttribute('aria-pressed', playing ? 'true' : 'false')

    var baseLabel = button.getAttribute('data-video-title') || 'video'
    button.setAttribute(
      'aria-label',
      (playing ? 'Pause' : 'Play') + ': ' + baseLabel
    )

    button.classList.toggle('is-playing', playing)
  }

  function getPlayer(target) {
    if (target.kind !== 'vimeo') return null
    if (typeof Vimeo === 'undefined') return null
    if (!target.el._player) {
      target.el._player = new Vimeo.Player(target.el)
    }
    return target.el._player
  }

  function playTarget(target) {
    if (target.kind === 'vimeo') {
      var player = getPlayer(target)
      if (!player) return
      player.play().catch(function () {})
    } else {
      var video = target.el
      if (!video.paused) return
      var p = video.play()
      if (p && typeof p.catch === 'function') p.catch(function () {})
    }
  }

  function pauseTarget(target) {
    if (target.kind === 'vimeo') {
      var player = getPlayer(target)
      if (!player) return
      player.pause()
    } else {
      var video = target.el
      if (!video.paused) video.pause()
    }
  }

  function targetFromEl(el) {
    var dm = el.closest('deferred-media')
    if (!dm) return null
    if (el.classList.contains('js-vimeo')) return { kind: 'vimeo', el: el, dm: dm }
    if (el.classList.contains('js-html5-video')) return { kind: 'html5', el: el, dm: dm }
    return null
  }

  // Shared IntersectionObserver — plays a video when ≥50% visible, pauses it
  // otherwise. Respects the data-user-paused flag set by manual pause clicks.
  var io = new IntersectionObserver(
    function (entries) {
      // Sort so the most-visible entry is processed last and "wins" after
      // pauseAll() runs.
      entries
        .slice()
        .sort(function (a, b) {
          return a.intersectionRatio - b.intersectionRatio
        })
        .forEach(function (entry) {
          var target = targetFromEl(entry.target)
          if (!target) return

          if (entry.intersectionRatio >= 0.5) {
            if (entry.target.dataset.userPaused === '1') return
            pauseAll()
            playTarget(target)
          } else {
            pauseTarget(target)
          }
        })
    },
    { threshold: [0, 0.5] }
  )

  var INSET_PX = 16 // padding inside the video area

  function positionZoomedToggle(button, videoAspect) {
    var dm = button.closest('deferred-media')
    if (!dm) return

    var cw = dm.offsetWidth
    var ch = dm.offsetHeight
    if (!cw || !ch) return

    var containerAspect = cw / ch
    var videoW, videoH

    if (containerAspect > videoAspect) {
      // container is wider than video — bars on sides
      videoH = ch
      videoW = ch * videoAspect
    } else {
      // container is taller than video — bars top/bottom
      videoW = cw
      videoH = cw / videoAspect
    }

    var barX = (cw - videoW) / 2
    var barY = (ch - videoH) / 2

    button.style.bottom = barY + INSET_PX + 'px'
    button.style.left = barX + INSET_PX + 'px'
  }

  function observeZoomedAspect(button, aspect) {
    positionZoomedToggle(button, aspect)
    new ResizeObserver(function () {
      positionZoomedToggle(button, aspect)
    }).observe(button.closest('deferred-media'))
  }

  function initVimeoToggle(button, target) {
    var player = new Vimeo.Player(target.el)
    target.el._player = player

    player.on('playing', function () {
      var posterOverlay = target.dm.querySelector('[data-vimeo-poster]')
      if (posterOverlay) {
        posterOverlay.style.opacity = '0'
        posterOverlay.style.pointerEvents = 'none'
      }
      setVideoToggleState(button, true)
    })

    player.on('pause', function () {
      setVideoToggleState(button, false)
    })

    player.ready().then(function () {
      setVideoToggleState(button, true)
    })

    if (button.hasAttribute('data-zoomed-toggle')) {
      Promise.all([player.getVideoWidth(), player.getVideoHeight()]).then(
        function (dims) {
          observeZoomedAspect(button, dims[0] / dims[1])
        }
      )
    }
  }

  function initHtml5Toggle(button, target) {
    var video = target.el

    video.addEventListener('play', function () {
      setVideoToggleState(button, true)
    })

    video.addEventListener('pause', function () {
      setVideoToggleState(button, false)
    })

    // Initial state reflects whether autoplay is already running.
    setVideoToggleState(button, !video.paused)

    if (button.hasAttribute('data-zoomed-toggle')) {
      var applyAspect = function () {
        if (!video.videoWidth || !video.videoHeight) return
        observeZoomedAspect(button, video.videoWidth / video.videoHeight)
      }
      if (video.readyState >= 1) {
        applyAspect()
      } else {
        video.addEventListener('loadedmetadata', applyAspect, { once: true })
      }
    }
  }

  function initPlayToggles() {
    document
      .querySelectorAll('.video-toggle:not([data-toggle-init])')
      .forEach(function (button) {
        var target = getMediaTarget(button)
        if (!target) return

        // For Vimeo we need the SDK before we can wire up the player.
        if (target.kind === 'vimeo' && typeof Vimeo === 'undefined') return

        button.dataset.toggleInit = '1'
        io.observe(target.el)

        // Stop pointer/touch events from reaching Swiper so tapping the
        // button doesn't also open the zoomed gallery modal.
        ;['pointerdown', 'touchstart'].forEach(function (evt) {
          button.addEventListener(evt, function (e) {
            e.stopPropagation()
          })
        })

        if (target.kind === 'vimeo') {
          initVimeoToggle(button, target)
        } else {
          initHtml5Toggle(button, target)
        }
      })
  }

  function pauseAll() {
    document.querySelectorAll('iframe.js-vimeo').forEach(function (iframe) {
      if (typeof Vimeo === 'undefined') return
      if (!iframe._player) {
        iframe._player = new Vimeo.Player(iframe)
      }
      iframe._player.pause()
    })

    document.querySelectorAll('video.js-html5-video').forEach(function (video) {
      if (!video.paused) video.pause()
    })

    document
      .querySelectorAll('.video-toggle.is-playing')
      .forEach(function (btn) {
        setVideoToggleState(btn, false)
      })
  }

  document.addEventListener('DOMContentLoaded', function () {
    initPlayToggles()

    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.removedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return
          var removed = node.matches && node.matches('.js-html5-video, iframe.js-vimeo')
            ? [node]
            : node.querySelectorAll
              ? node.querySelectorAll('.js-html5-video, iframe.js-vimeo')
              : []
          removed.forEach && removed.forEach(function (el) {
            io.unobserve(el)
          })
        })
      })
      initPlayToggles()
    }).observe(document.body, {
      childList: true,
      subtree: true,
    })
  })

  function pushToggleEvent(button, playing) {
    window.dataLayer = window.dataLayer || []
    var payload = {
      event: playing ? 'pdp_video_play_click' : 'pdp_video_pause_click',
    }
    if (button.dataset.eventStyleColor) {
      payload.event_style_color = button.dataset.eventStyleColor
    }
    window.dataLayer.push(payload)
  }

  document.addEventListener(
    'click',
    function (e) {
      var button = e.target.closest('.video-toggle')
      if (!button) return

      var target = getMediaTarget(button)
      if (!target) return

      e.preventDefault()
      e.stopPropagation()

      if (target.kind === 'vimeo') {
        if (typeof Vimeo === 'undefined') return
        var iframe = target.el
        if (!iframe._player) {
          iframe._player = new Vimeo.Player(iframe)
        }
        iframe._player.getPaused().then(function (paused) {
          if (paused) {
            pauseAll()
            delete iframe.dataset.userPaused
            iframe._player.play()
            setVideoToggleState(button, true)
            pushToggleEvent(button, true)
          } else {
            iframe.dataset.userPaused = '1'
            iframe._player.pause()
            setVideoToggleState(button, false)
            pushToggleEvent(button, false)
          }
        })
      } else {
        var video = target.el
        if (video.paused) {
          pauseAll()
          delete video.dataset.userPaused
          var p = video.play()
          if (p && typeof p.then === 'function') {
            p.then(function () {
              setVideoToggleState(button, true)
            }).catch(function () {
              setVideoToggleState(button, false)
            })
          } else {
            setVideoToggleState(button, true)
          }
          pushToggleEvent(button, true)
        } else {
          video.dataset.userPaused = '1'
          video.pause()
          setVideoToggleState(button, false)
          pushToggleEvent(button, false)
        }
      }
    },
    true
  )

  // When the PDP zoomed gallery modal opens, pause any underlying gallery
  // videos that are currently playing and flag them so we can resume on
  // close. The zoomed clone lives inside the modal, so scope by
  // `!modal.contains(el)` to leave it alone. We deliberately do NOT set
  // `data-user-paused` — the IntersectionObserver should still resume play
  // when the modal closes and the underlying video returns to view.
  function isZoomGalleryEvent(event) {
    return typeof event?.detail === 'string' && event.detail.indexOf('zoom-gallery') !== -1
  }

  function getModalFromEvent(event) {
    return document.getElementById(event.detail)
  }

  document.addEventListener('modal-dialog::open', function (event) {
    if (!isZoomGalleryEvent(event)) return
    var modal = getModalFromEvent(event)

    document.querySelectorAll('video.js-html5-video').forEach(function (video) {
      if (modal && modal.contains(video)) return
      if (video.paused) return
      var target = targetFromEl(video)
      if (!target) return
      video.dataset.zoomWasPlaying = '1'
      pauseTarget(target)
    })

    document.querySelectorAll('iframe.js-vimeo').forEach(function (iframe) {
      if (modal && modal.contains(iframe)) return
      if (typeof Vimeo === 'undefined') return
      if (!iframe._player) {
        iframe._player = new Vimeo.Player(iframe)
      }
      iframe._player.getPaused().then(function (paused) {
        if (paused) return
        iframe.dataset.zoomWasPlaying = '1'
        iframe._player.pause()
      })
    })
  })

  document.addEventListener('modal-dialog::close', function (event) {
    if (!isZoomGalleryEvent(event)) return
    var modal = getModalFromEvent(event)

    document
      .querySelectorAll('[data-zoom-was-playing="1"]')
      .forEach(function (el) {
        if (modal && modal.contains(el)) return
        var target = targetFromEl(el)
        delete el.dataset.zoomWasPlaying
        if (!target) return
        playTarget(target)
      })
  })

  // Expose globally for other scripts. `pauseAllVimeo` is preserved as an
  // alias for backwards compatibility with any callers from before the
  // Vimeo → MP4 migration.
  window.pauseAllVideos = pauseAll
  window.pauseAllVimeo = pauseAll
})()
